import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    blue: {
      50: '#e8e9f0',
      100: '#c5c7db',
      200: '#9fa2c4',
      300: '#787cad',
      400: '#5b609c',
      500: '#1d2252',  // Your primary blue
      600: '#1a1e4a',
      700: '#161941',
      800: '#121437',
      900: '#0a0c26',
    },
  },
  components: {
    // Folder-tab look (theme-level so every Tabs matches): grey strip, active
    // tab is white with a navy top bar and joins the panel below.
    Tabs: {
      variants: {
        folder: {
          root: { width: '100%' },
          tablist: {
            bg: 'gray.100',
            // inset shadow paints under child backgrounds, so the selected
            // tab's white bg covers it (a real border would be clipped by
            // the tablist's overflow and stay visible under the tab)
            boxShadow: 'inset 0 -2px 0 var(--chakra-colors-gray-200)',
          },
          tab: {
            fontWeight: 'semibold',
            color: 'gray.600',
            borderTop: '3px solid',
            borderTopColor: 'transparent',
            _hover: { bg: 'gray.200' },
            _selected: {
              bg: 'white',
              color: '#1d2252',
              borderTopColor: '#1d2252',
              _hover: { bg: 'white' },
            },
          },
          tabpanel: {
            bg: 'white',
            border: '1px solid',
            borderColor: 'gray.200',
            borderTop: 'none',
          },
        },
      },
      defaultProps: { variant: 'folder' },
    },
    Button: {
      defaultProps: {
        colorScheme: 'blue',
      },
    },
  },
});

export default theme;